import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel } from "@mui/material";

const Settings = () => {
  return (
    <Box sx={{ padding: "20px", marginLeft: "220px" }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
        ⚙️ Settings
      </Typography>

      <FormControl fullWidth sx={{ marginBottom: "20px" }}>
        <InputLabel>Theme</InputLabel>
        <Select defaultValue="light">
          <MenuItem value="light">🌞 Light Mode</MenuItem>
          <MenuItem value="dark">🌙 Dark Mode</MenuItem>
        </Select>
      </FormControl>

      <FormControlLabel control={<Switch defaultChecked />} label="Enable Notifications" />
    </Box>
  );
};

export default Settings;
